<template>
    <div class="tools-tab tools-tab-tags">
        <ul class="list list-tags" v-if="tags.length">
            <li v-for="tag in tags" :class="[hasTag(tag) ? 'is-active' : '']" @click="select(tag)">
                <span>{{ tag.name }}</span>
                <icon name="cancel" v-if="hasTag(tag)" />
                <icon name="check" v-else />
            </li>
        </ul>
        <div class="empty" v-else>
            {{ $t('page.roster.tools.tags_none') }}
        </div>
    </div>
</template>

<script>
// import events from '../../../events/events';
import shared from '../../../pages/planning/shared';

export default
{
    name: 'Tags',

    props: ['item'],

    data() {
        return {
            shared: shared.state,
        }
    },

    computed:
    {
        tags()
        {
            // no user set? return all tags!
            if ( ! this.item.assigned) return this.sort(this.shared.tags);

            // otherwise filter tags by current user
            return this.sort(this.filter(this.shared.tags));
        },
    },

    methods:
    {
        filter(tags)
        {
            // get all tags of assigned user
            let user = shared.getUser(this.item.user);

            return _.filter(tags, tag =>
            {
                // allow to include currently selected tag, even though it might
                // not be assigned to user anymore
                if (this.hasTag(tag)) return true;

                return (user.tags.indexOf(tag.id) !== -1);
            })
        },

        sort(tags)
        {
            return _.sortBy(tags, ['name']);
        },

        hasTag(tag)
        {
            return (this.item.tags.indexOf(tag.id) !== -1);
        },

        select(tag)
        {
            let tags = _.clone(this.item.tags);

            if (this.hasTag(tag))
            {
                _.pull(tags, tag.id);

                this.update(tags);
            }
            else
            {
                tags.push(tag.id);

                this.update(tags);
            }
        },

        update(tags)
        {
            this.$http.put(
            '/api/items/' + this.item.id + '/tags',
            {
                tags: tags
            })
            .then(response =>
            {
                this.item.tags = tags;
                // this.$set(this.item, 'tags', tags);

                // this.$tools.close();
            })
            .catch(error =>
            {
                // error
            });
        },
    }
}
</script>



// WEBPACK FOOTER //
// Tags.vue?12a07166